<template>
  <div class="testimonials">
    <h2>From Our Dog Lovers</h2>
    <div class="testimony">
      <div class="testimony_content">
        <h3>Kassim, 23</h3>
        <p>
          <span>&ldquo; </span>Pet Mobi makes caring for me to give premium care
          to my Miju when i’m away. The caregivers have been amazing for her as
          they are caring and make her feel safe.<span> &bdquo;</span>
        </p>
      </div>
      <div class="testimony_img">
        <div class="img"></div>
        <div class="yellow"></div>
        <div class="red"></div>
      </div>
    </div>
    <div class="testimonials_controls">
      <button class="active control"></button><button class="control"></button
      ><button class="control"></button><button class="control"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Testimonials",
};
</script>

<style lang="scss" src="../styles/testimonials.scss"></style>
